import React, {useContext} from 'react';
import {Context} from '../../index';
import Container from '../../components/ui/Container';
import Button from '../../components/ui/Button';
import SectionHeading from '../../components/ui/SectionHeading';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Seo from '../../components/ui/Seo';
import styles from './LayoutsAndDesign.module.css';

const priceGroups = [
    {
        title: 'Дизайн информационных и рекламных материалов',
        items: [
            ['Визитная карточка', 'от 500 до 1 000 руб.'],
            ['Визитка по готовому шаблону', '300 руб.'],
            ['Смена информации на готовом макете визитки', '100 руб.'],
            ['Грамоты и сертификаты', 'от 1 000 до 2 000 руб.'],
            ['Открытки и пригласительные', 'от 2 500 до 5 000 руб.'],
            ['Листовки A4/A5, одна сторона', 'от 1 000 до 3 000 руб.'],
            ['Плакат, афиша, постер', 'от 1 000 до 3 000 руб.'],
            ['Буклет, трифолд', 'от 1 000 до 3 000 руб.'],
        ],
    },
    {
        title: 'Вывески, таблички, баннеры',
        items: [
            ['Простой текстовый макет', 'от 500 до 1 000 руб.'],
            ['Сложное графическое решение', 'от 1 000 до 5 000 руб.'],
            ['Макет стенда', 'от 1 000 до 3 000 руб.'],
            ['Оформление подарочной бумаги', 'от 800 до 1 200 руб.'],
        ],
    },
    {
        title: 'Идентификационные материалы и текст',
        items: [
            ['Разработка логотипа', 'от 12 000 руб.'],
            ['Обрисовка логотипа в векторный формат', 'от 3 000 до 6 000 руб.'],
            ['Набор текста, формат A4', '50 руб.'],
            ['Верстка текста, 1 полоса', '200 руб.'],
        ],
    },
];

const LayoutsAndDesign = () => {
    const {global} = useContext(Context);
    global.setIsAdminPage(false);

    return (
        <Container className={styles.page}>
            <Seo
                title="Макеты и дизайн — 4 Цвета"
                description="Услуги дизайна, верстки, подготовки и проверки макетов для печати в типографии 4 Цвета."
            />
            <Breadcrumbs items={[{label: 'Макеты и дизайн'}]}/>
            <section className={styles.hero}>
                <div>
                    <p className={styles.kicker}>Макеты и дизайн</p>
                    <h1>Подготовим файл к печати или разработаем макет с нуля</h1>
                    <p>Поможем, если нет готового макета, нужно проверить технические требования или адаптировать файл под печать.</p>
                    <div className={styles.actions}>
                        <Button variant="secondary" href={require('../../file/Trebovania.pdf')} target="_blank" rel="noreferrer">Скачать требования</Button>
                    </div>
                </div>
            </section>

            <section className={styles.section}>
                <SectionHeading
                    eyebrow="Расценки"
                    title="Стоимость зависит от сложности задачи"
                    text=""
                />
                <div className={styles.priceGroups}>
                    {priceGroups.map((group) => (
                        <article key={group.title} className={styles.priceGroup}>
                            <h2>{group.title}</h2>
                            <div>
                                {group.items.map(([name, price]) => (
                                    <div key={name} className={styles.priceRow}>
                                        <span>{name}</span>
                                        <strong>{price}</strong>
                                    </div>
                                ))}
                            </div>
                        </article>
                    ))}
                </div>
            </section>

            <section className={styles.section}>
                <SectionHeading
                    eyebrow="Требования"
                    title="Технические требования к макетам"
                    text=""
                />
                <Button variant="secondary" href={require('../../file/Trebovania.pdf')} target="_blank" rel="noreferrer">Скачать PDF</Button>
            </section>
        </Container>
    );
};

export default LayoutsAndDesign;
